import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';


// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'products/displayProduct',
    pluginName: 'PRODUCT',
    entityName: 'DISPLAY_PRODUCT',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
});

// Fetch PCProduct action creators
export const fetchDisplayProductInit = () => { return crudActions.fetchInit(); }
export const fetchDisplayProductStart = () => { return crudActions.fetchStart(); }
export const fetchDisplayProductSuccess = () => { return crudActions.fetchSuccess(); }
export const fetchDisplayProductFail = () => { return crudActions.fetchFail(); }
export const fetchDisplayProduct = filter => {
    return async dispatch => {
        await crudActions.fetch(dispatch, filter);
    }
}

export const printLabel = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/products/displayProduct/print_label', data);
            if (res.data.status === 200) {
                return res.data.status === 200;
            }
            else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
}